import React from 'react';
import {ListGroup, ListGroupItem} from 'react-bootstrap';

const styles = {
  required: {
    color: 'red',
    fontWeight: 'bold'
  }
};

export default class InfoMsg extends React.Component {

  render() {
    if (this.props.text == '') {
      return null;
    }

    return (
      <ListGroup>
        <ListGroupItem bsStyle={this.props.styleBS}>{this.props.text}</ListGroupItem>
      </ListGroup>
    );
  }
};



// WEBPACK FOOTER //
// src/api/InfoMsg.jsx